import { useMemo } from 'react'

export function useIsWebView() {
  return useMemo(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false
    }

    try {
      const ua = navigator.userAgent || ''
      const isIOS = /AppleWebKit(?!.*Safari)/i.test(ua)
      const isAndroid = /wv|Version\/[\d.]+/i.test(ua)

      const win = window as any
      const injected =
        (typeof win.ReactNativeWebView !== 'undefined') ||
        (win.webkit && typeof win.webkit.messageHandlers !== 'undefined') ||
        (typeof win.flutter_inappwebview !== 'undefined')

      return isIOS || isAndroid || !!injected
    } catch (e) {
      console.error('Error in useIsWebView', e)
      return false
    }
  }, [])
}
